import { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleResetPassword = async (e) => {
    e.preventDefault(); // Prevent form default submit behavior
    const auth = getAuth();

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent!');
      setError(null);
    } catch (err) {
      setError(err.message);
      setMessage(null);
    }
  };

  return (
    <>
      <div className="main reset-password">
        <div className="content static">
          <h1>Reset Password</h1>
          <p>If your account exists, you will receive an email to your inbox asking you to confirm a password reset. Make sure to check your spam.</p>
          <form onSubmit={handleResetPassword} className='reset-form'>
            <input
              type="email"
              placeholder='Email...'
              id='email'
              name='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input type="submit" className='login-button' value="Reset Password" />
          </form>
          {message && <p style={{ color: 'lightgreen' }}>{message}</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
      </div>
    </>
  );
};